// Get the data inserted in DOM using JsGlobals in WP.

const element = document.getElementById("avain-js-globals");
const dataRaw = element.getAttribute("data-value");
const data = JSON.parse(dataRaw);
element.parentNode.removeChild(element);

export default { ...data.globals };

export const translations = { ...data.translations };
